import BaseModel from "lib/model";

export default BaseModel.extend({
    session: {
        brandId: {
            type: "string",
            required: true,
            default: "",
        },
    },
    props: {
        name: "string",
        store: "string",
        email: "string",
        phone: "string",
        website: "string",
        brands: "string",
        store_classes: "string",
        store_description: "string",
    },

    urlRoot() {
        return `/brand/${this.brandId}/request-access`;
    },
});
